import React, { useEffect, useState, useRef } from "react";
import { makeStyles,createStyles,Theme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Edit } from "@material-ui/icons";
import {
  getCenterInfo,
  getDoctorQualification,
  getDoctorSpecialization,
  postRefDoctor,
  resetRefDoctor,
  getRefDoctor,
  updateRefDoctor,
  resetBookingData,
} from "../../GenomicsAdmin-Panel/actions/GenomicsAdminAction";
import {
  Grid,
  Typography,
  InputLabel,
  TextField,
  FormControl,
  FormControlLabel,
  Radio,
  Button,
  RadioGroup,
  InputAdornment,
  TableContainer,
  withStyles,
  TableCell,
  TableRow,
  TableHead,
  Table,
  TableBody,
  Paper,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "90%",
    margin: "25px auto",
  },
  tcolor: {
    color: "black",
    fontWeight: "bolder",
  },
  table: {
    minWidth: 650,
  },
  row: {
    color: "black",
    fontSize: "larger",
    fontWeight: "bolder",
  },
  margin: {
    margin: theme.spacing(1),
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  gap: {
    fontSize: "14px",
    margin: "0 -40px 0 40px",
  },
  start: {
    display: "flex",
    justifyContent: "flex-start",
  },
  formContorlLabel: {
    padding: "0 0 0 25px",
    margin: "0 0 0 15px",
    color: "rgba(0, 0, 0, 0.54)",
  },
  select: {
    margin: "0 0 0 -8px",
    minWidth: "155px",
    width: "100%",
    height: "40px",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  spacebtm: {
    marginBottom: 15,
  },
  formadd: {
    width: "100%",
  },
  button1: {
    margin: "0 8px",
    height: 42,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "155px",
  },
  tableContainer: {
    marginTop: "2rem",
    position: "sticky",
    top: "200px",
},
}));
const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#924A91",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);

interface Props {
  getDoctorSpecialization: any;
  doctorSpec: any;
  getDoctorQualification: any;
  doctorQual: any;
  getCenterInfo: any;
  postRefDoctor: any;
  centerInfo: any;
  getRefDoctor: any;
  responseRefDoctor: any;
  resetRefDoctor: any;
  refDoctor:any;
  updateRefDoctor:any;
  page: any;
  setPage: any;
  resetBookingData:any;
}

const ReferringDoctor: React.FC<Props> = ({
  getDoctorSpecialization,
  doctorSpec,
  getCenterInfo,
  centerInfo,
  getDoctorQualification,
  postRefDoctor,
  doctorQual,
  getRefDoctor,
  responseRefDoctor,
  resetRefDoctor,
  refDoctor,
  updateRefDoctor,
  page,
  setPage,
  resetBookingData,
}) => {
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState<number>(50);
  const [editButton, setEditButton] = useState<boolean>(false);
  const history = useHistory();
  const [doctorId, setdoctorId] = useState<any>();
  const [qualification, setQualification] = useState<any>([]);
  const [qualificationdef, setQualificationdef] = useState<any>([]);
  const [specilization, setSpecilization] = useState<any>([]);
  const [specilizationdef, setSpecilizationdef] = useState<any>([]);
  const [name, setName] = useState<any>("");
  const [dob, setDob] = useState<any>("");
  const [gender, setGender] = useState<any>("");
  const [mobileNo, setMobile] = useState<any>("");
  const [centre, setCentre] = useState<any>([]);
  const [clinicAddress, setClinicAddress] = useState<any>("");
  const [residentialAddress, setResidentialAddress] = useState<any>("");
  const timer = useRef<any>(0);
  const [customer_email, setCustomer_email] = useState<String>();
  const [key, setKey] = useState<any>("");
  const [mobileValidation, setMobileValidation] = useState<any>({
    mobileNo: true,
  });
  useEffect(() => {
    getCenterInfo();
    getDoctorSpecialization();
    getDoctorQualification();
    getRefDoctor();
    // postRefDoctor();
  }, []);
  const submitRefferingDoctorForm = async (e: any) => {
    e.preventDefault();
    const data = {
      specialization: specilization,
      qualification: qualification,
      name: name,
      age: dob,
      gender: gender,
      mobile: mobileNo,
      clinic_address: clinicAddress,
      residential_address: residentialAddress,
      centre: centre,
      email: customer_email ,
      org_type: "genomics",
    };
    const dataEdit = {
      specialization: specilization,
      qualification: qualification,
      name: name,
      age: dob,
      gender: gender,
      mobile: mobileNo,
      clinic_address: clinicAddress,
      residential_address: residentialAddress,
      centre: centre,
      email: customer_email,
      org_type: "genomics",
      
    };
    if (specilization.length === 0) {
      delete data.specialization;
    }
    if (qualification.length === 0) {
      delete data.qualification;
    }
    if (dob === "") {
      delete data.age;
    }
    if (gender === "") {
      delete data.gender;
    }
    if (mobileNo === "") {
      delete data.mobile;
    }
    if (residentialAddress === "") {
      delete data.residential_address;
    }
    if (centre.length === 0) {
      delete data.centre;
    }

  if (editButton) {
    await updateRefDoctor(dataEdit,doctorId);
    getRefDoctor();
    resetBookingData();
    

  } else {
    await postRefDoctor(data);
    getRefDoctor();
    resetBookingData();

  }
  setEditButton(false);
  setGender("");
  setName("");
  setQualification("");
  setQualificationdef(false);
  setSpecilization("");
  setSpecilizationdef(false);
  setMobile("");
  setDob("");
  setResidentialAddress("");
  setCustomer_email("");
  setClinicAddress("");
  history.push("/dashboard/gnadmin/addDoctor");

 
};
const handleEditDoctor = (data: any) => {
  setEditButton(true);
  setGender(data?.gender);
  setName(data?.name);
  setQualificationdef(data?.qualification);
  setQualification(data?.qualification.map((id:any)=>id.id));
  setSpecilizationdef(data?.specialization)
  setSpecilization(data?.specialization.map((id:any)=>id.id));
  setMobile(data?.mobile);
  setDob(data?.age);
  setResidentialAddress(data?.residential_address);
  setCustomer_email(data?.email);
  setClinicAddress(data?.clinic_address)
  setdoctorId(data?.id)
  setKey(!key)
 
};
const handleChangePage = (
  event: React.MouseEvent<HTMLButtonElement> | null,
  newPage: number
) => {
  if (newPage > page) {
    let url = refDoctor.links && refDoctor.links.next.split("?")[1];
    getRefDoctor(`${url}`);
  } else if (newPage < page) {
    let url = refDoctor.links && refDoctor.links.previous.split("?")[1];
    getRefDoctor(`${url === undefined ? "" : url}`);
  }
  setPage(newPage);
};
  const verifyMobile = (type: any) => {
    const mobileRegEx = /^[6-9]\d{9}$/;
    if (type === "mobileNo" && !mobileRegEx.test(mobileNo.toString())) {
      setMobile((prev: any) => ({
        ...prev,
        mobileNo: false,
      }));
    }
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid container item xs={12}>
          <Typography variant="h4" component="h1" gutterBottom>
            REF DOCTOR CREATION
          </Typography>
        </Grid>
        <form
          onSubmit={submitRefferingDoctorForm}
          autoComplete="off"
          style={{ width: "100%" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <TextField
                required
                fullWidth
                label="Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">Dr.</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
              key={key}
                onChange={(event, newValue) => {
                  let ids: any = [];
                  newValue.map((val: any) => {
                    let obj = JSON.parse(JSON.stringify(val, null, " "));
                    ids.push(obj.id);
                  });
                  setQualification(ids);
                }}
                multiple
                limitTags={1}
                disableClearable
                freeSolo
                blurOnSelect
                options={doctorQual?.results||[]}
                disableCloseOnSelect
                getOptionLabel={(option: any) => option.qualification}
                // onInputChange={(event, newInputValue) => {
                //   getCenterInfo(`?name=${newInputValue}`);
                // }}
                defaultValue={qualificationdef}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Qualification/Degree"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
              key={key}
                id="center"
                onChange={(event, newValue) => {
                  let ids: any = [];
                  newValue.map((val: any) => {
                    let obj = JSON.parse(JSON.stringify(val, null, " "));
                    ids.push(obj.id);
                  });
                  setSpecilization(ids);
                }}
                multiple
                limitTags={1}
                disableClearable
                freeSolo
                blurOnSelect
                options={doctorSpec?.results}
                disableCloseOnSelect
                getOptionLabel={(option: any) => option.specialization}
                // onInputChange={(event, newInputValue) => {
                //   getCenterInfo(`?name=${newInputValue}`);
                // }}
                defaultValue={specilizationdef}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Specialization"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Mobile No."
                variant="outlined"
                type="number"
                inputProps={{
                  maxLength: "10",
                }}
                value={mobileNo || ""}
                onChange={(e) => {
                  return setMobile(
                    Math.max(0, parseInt(e.target.value))
                      .toString()
                      .slice(0, 10)
                  );
                }}
                onBlur={() => verifyMobile("mobileNo")}
                onFocus={() => {
                  setMobileValidation((prev: any) => ({
                    ...prev,
                    mobileNo: true,
                  }));
                }}
                helperText={
                  !mobileValidation.mobileNo && (
                    <span style={{ color: "red", fontSize: "large" }}>
                      Incorrect Mobile No.
                    </span>
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={3}>
            <TextField
                name="DOB"
                type="number"
                value={dob}
                label="Age(years)"
                variant="outlined"
                onChange={(e) => setDob(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                required
                fullWidth
                label="Hospital/Doctor Address"
                variant="outlined"
                value={clinicAddress}
                onChange={(e) => setClinicAddress(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Residential Address"
                variant="outlined"
                value={residentialAddress}
                onChange={(e) => setResidentialAddress(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                className="input"
                name="customer_email"
                label="Email"
                type="email"
                // placeholder="customer.reports@redcliffelabs.com"
                value={customer_email}
                variant="outlined"
                style={{ margin: "0", width: "100%" }}
                onChange={(e) =>
                  setCustomer_email(e.target.value as String)
                }
              // required
              />

            </Grid>
            <Grid item xs={3} md={1}>
              <InputLabel
                htmlFor="gender"
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: "larger",
                  marginTop: "12px",
                }}
              >
                Gender:
              </InputLabel>
            </Grid>
            <Grid item xs={9} md={5}>
              <FormControl component="fieldset">
                <RadioGroup name="gender" style={{ flexDirection: "row" }}>
                  <FormControlLabel
                    control={<Radio />}
                    label="Male"
                    checked={gender === "male"}
                    value="male"
                    onClick={() => setGender("male")}
                  />
                  <FormControlLabel
                    control={<Radio />}
                    label="Female"
                    checked={gender === "female"}
                    value="female"
                    onClick={() => setGender("female")}
                  />
                  <FormControlLabel
                    control={<Radio />}
                    label="Other"
                    checked={gender === "other"}
                    value="other"
                    onClick={() => setGender("other")}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            direction="row"
            alignItems="center"
            justify="center"
          >
            <Grid item xs={12} sm={4} md={2}>
              <Button
                type="submit"
                variant="contained"
                style={{ height: "56px" }}
                fullWidth
                color="secondary"
              >
                 {editButton ? "Update" : "Create"}
              </Button>
            </Grid>
            {!editButton ? (
            <Grid item xs={12} sm={4} md={2}>
              <Button
                variant="contained"
                color="primary"
                style={{ height: "56px" }}
                fullWidth
                onClick={() => history.push("/dashboard/gnadmin/addDoctor")}
              >
                Reset
              </Button>
            </Grid>
            ) : (
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ height: 55 }}
                  fullWidth
                  onClick={() =>
                    history.push("/dashboard/gnadmin/addDoctor")
                  }
                >
                  Cancel Update
                </Button>
              </Grid>
            )}
          </Grid>
        </form>
      </Grid>
      <TableContainer className={classes.tableContainer} component={Paper} style={{ maxHeight: "700px" }}>

        <Table stickyHeader aria-label="simple table">
          <TableHead>
            <StyledTableRow>
              <StyledTableCell align="center">Doctor Name</StyledTableCell>
              <StyledTableCell align="center">Email Id</StyledTableCell>
              <StyledTableCell align="center"> Address</StyledTableCell>
              <StyledTableCell align="center"> Edit</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {refDoctor && refDoctor.results && refDoctor.results.length > 0 && refDoctor.results.map((results: any, index: any) => {
              return (
                <StyledTableRow key={index} >
                  <StyledTableCell align="center">{results?.name}</StyledTableCell>
                  <StyledTableCell align="center">{results?.email}</StyledTableCell>
                  <StyledTableCell align="center">{results?.clinic_address}</StyledTableCell>
                  <StyledTableCell align="center">
                            <Button color="primary" variant="contained">
                              <Edit onClick={() => handleEditDoctor(results)} />
                            </Button>
                          </StyledTableCell>

                </StyledTableRow>
              )
            })}
          </TableBody>
          {/* <TableFooter>
            <StyledTableRow>
            <TablePagination
                    colSpan={6}
                    count={refDoctor?.count || 0}
                    rowsPerPageOptions={[]}
                    rowsPerPage={rowsPerPage}
                    // onChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    SelectProps={{
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                  />
            </StyledTableRow>
          </TableFooter> */}
        </Table>
      </TableContainer>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  centerInfo: state.GenomicsAdminReducer.centerInfo,
  doctorSpec: state.GenomicsAdminReducer.doctorSpec,
  doctorQual: state.GenomicsAdminReducer.doctorQual,
  responseRefDoctor: state.GenomicsAdminReducer.responseRefDoctor,
  refDoctor: state.GenomicsAdminReducer.refDoctor
});

export default connect(mapStateToProps, {
  getCenterInfo,
  getDoctorQualification,
  getDoctorSpecialization,
  postRefDoctor,
  resetRefDoctor,
  getRefDoctor,
  updateRefDoctor,
  resetBookingData,
})(ReferringDoctor);
function rowsPerPageOptions(rowsPerPageOptions: any, arg1: string) {
  throw new Error("Function not implemented.");
}

